import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Typography,
    CircularProgress,
    Paper,
    Chip
} from "@material-ui/core";
import * as Yup from "yup";
import { BackButton } from '../../sc-utilities';
import Autocomplete from "@material-ui/lab/Autocomplete";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
});

const LicensePrototypeForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations, permissions, usedFor } = props;

    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                    setSubmitting(false);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, handleChange, handleBlur, handleSubmit, setFieldValue, isSubmitting } = formikProps;

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations["name"] || "Name"}
                                label={translations["name"] || "Name"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="Hardware"
                                value={values.Hardware}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Hardware && touched.Hardware)}
                                placeholder={translations["hardware"] || "Hardware"}
                                label={translations["hardware"] || "Hardware"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <Autocomplete
                                name={'UsedFor'}
                                multiple
                                id="UsedForMultiSelect"
                                options={usedFor || []}
                                getOptionLabel={(option) => option.label}
                                filterSelectedOptions
                                value={values.UsedFor}
                                onChange={(_, value) => setFieldValue('UsedFor', value)}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" fullWidth={true} label={`${translations["please_choose_for"] || "Please choose for what will be used"}`} />
                                )}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip label={option.label} {...getTagProps({ index })} />
                                    ))
                                }
                            />
                            <Autocomplete
                                name={'Permissions'}
                                multiple
                                id="PermissionsMultiSelect"
                                options={permissions || []}
                                getOptionLabel={(option) => option.label}
                                filterSelectedOptions
                                value={values.Permissions}
                                onChange={(_, value) => setFieldValue('Permissions', value)}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" fullWidth={true} label={`${translations["please_choose_permissions"] || "Please select permissions for license"}`} />
                                )}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip label={option.label} {...getTagProps({ index })} />
                                    ))
                                }
                            />
                            {formSettings.ButtonSubmit ? (
                                <Button
                                    className={classes.submit}
                                    variant="contained"
                                    type="submit"
                                    disabled={isSubmitting || !(isValid && dirty)}
                                >
                                    {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                </Button>
                            ) : null}
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
};

export default withStyles(styles, { withTheme: true })(LicensePrototypeForm);
